import React from "react";
import { withRouter } from "react-router-dom";
import LoadingIndicator from "components/LoadingIndicator";
import { getOnboardingLinkToken } from "api/api";
import { displayGenericError } from "common/notifications";

class OnboardingLinkPage extends React.Component {
  componentDidMount() {
    const { ref, code } = this.props.match.params;
    getOnboardingLinkToken(ref, code)
      .then(response => {
        localStorage.setItem("ACCESS_TOKEN", response.accessToken);
        window.location = "/pages/onboarding";
      })
      .catch(error => {
        displayGenericError(error);
        this.props.history.push("/login");
      });
  }

  render() {
    return <LoadingIndicator />;
  }
}

export default withRouter(OnboardingLinkPage);
